"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Neptune = window.Neptune || {};

exports.default = Neptune;